import setup from './moduleSetup';

export default {
    name: 'cycleCount',
    before: [],
    after: [],
    setup,
};
